import { render, staticRenderFns } from "./DetailReceipt.vue?vue&type=template&id=03742f22&scoped=true&"
import script from "./DetailReceipt.vue?vue&type=script&lang=js&"
export * from "./DetailReceipt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03742f22",
  null
  
)

export default component.exports